import { TimeOccurrenceEngine } from '../../engines/time/time_engine';
import { ITimeOccurrenceDatatype } from '../../datastore/time/data_types';
import { ICorrector } from '../contracts';
import { Duration } from '../../servants/data_types';
import { TimeOccurrenceServant } from '../../servants/time/time_occurrence_servant';
import { TimeStartEndIdentifierEnum } from '../../engines/time/time_types';

export class timeLowerBoundCorrector {
  adjustedTime: ITimeOccurrenceDatatype;
  constructor(
    private ngTimeOccurrenceEngine: TimeOccurrenceEngine,
    private ngPhxCalendarConfiguration: any,
    private ngTimeOccurrenceServant: TimeOccurrenceServant
  ) {}
  timeStartEndCorrector(storeToCorrect: ITimeOccurrenceDatatype[]): ITimeOccurrenceDatatype[] {
    if (!_.isUndefined(this.adjustedTime)) {
      _.remove(storeToCorrect, this.adjustedTime);
    }

    const hourEnd: number = parseInt(this.ngPhxCalendarConfiguration.hourEnd, 10) + 1;
    let timeToCorrect: ITimeOccurrenceDatatype = _.find(storeToCorrect, (time: ITimeOccurrenceDatatype) => {
      return (
        !this.ngTimeOccurrenceServant.isTimeOccurrenceStartBeforeEnd(time) ||
        !this.ngTimeOccurrenceServant.isTimeOccurrenceInEndWindow(time)
      );
    });

    if (!!timeToCorrect) {
      _.remove(storeToCorrect, timeToCorrect);

      let newTime: ITimeOccurrenceDatatype = this.ngTimeOccurrenceServant.shiftTimeOccurrenceToBound(
        timeToCorrect,
        TimeStartEndIdentifierEnum.End,
        hourEnd
      );
      this.adjustedTime = newTime;

      storeToCorrect.push(this.adjustedTime);
    }
    return storeToCorrect;
  }
}

angular
  .module('ui-ng-calendar')
  .factory(
    'timeLowerBoundCorrector',
    (
      ngTimeOccurrenceEngine: TimeOccurrenceEngine,
      ngPhxCalendarConfiguration: any,
      ngTimeOccurrenceServant: TimeOccurrenceServant
    ) => new timeLowerBoundCorrector(ngTimeOccurrenceEngine, ngPhxCalendarConfiguration, ngTimeOccurrenceServant)
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/validation/correctors/time_lower_bound_corrector.ts